import React from "react";
import
{
    Form,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Row,
    Col
} from "reactstrap";
import InputTextComponent from "../../../../components/forms/InputTextComponent";
const validator = require("../../../../utils/validator/validator");
const stringUtil = require("../../../../utils/string/stringUtil");
const translator = require("../../../../utils/translator/translator");

class OpenItem extends React.Component
{
    constructor(props)
    {
        super(props);
        const { caption, quantity, unitPrice, vat, instructions } = this.props.values || {};
        this.state = {
            openItem: {
                caption: caption || '',
                quantity: quantity || '1',
                unitPrice: unitPrice || '',
                vat: vat || '',
                instructions: instructions || ''
            },
            error: {
                fieldName: '',
                message: ''
            },
        }
        this.updateOpenItem = this.updateOpenItem.bind(this);
        this.handleModalToggle = this.handleModalToggle.bind(this);
        this.handleModalOpen = this.handleModalOpen.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.hasErrors = this.hasErrors.bind(this);
        this.inputFieldRef = React.createRef();
    }


    updateOpenItem(fieldName, fieldValue)
    {
        const openItem = { ...this.state.openItem };
        openItem[fieldName] = fieldValue;
        this.setState({ openItem });
    }

    handleModalToggle()
    {
        if (this.props.onCancel != null)
            this.props.onCancel();
    }

    handleModalOpen()
    {
        this.inputFieldRef.current.focus();
    }

    hasErrors()
    {
        const openItem = this.state.openItem;
        let error;

        if (stringUtil.isStringNullOrEmpty(openItem.caption))
        {
            error = {
                fieldName: 'caption',
                message: translator.getLabel("item_name_cannot_be_empty")
            }
        }
        else if (!(validator.isInteger(openItem.quantity) && parseFloat(openItem.quantity) > 0)) 
        {
            error = {
                fieldName: 'quantity',
                message: translator.getLabel("quantity_should_be_a_number_greater_than_0")
            }
        }
        else if (!(validator.isNumeric(openItem.unitPrice) && parseFloat(openItem.unitPrice) >= 0)) 
        {
            error = {
                fieldName: 'unitPrice',
                message: translator.getLabel("unit_price_should_be_a_number_greater_than_0")
            }

        }
        else if (!(validator.isNumeric(openItem.vat) && parseFloat(openItem.vat) >= 0)) 
        {
            error = {
                fieldName: 'vat',
                message: translator.getLabel("vat_should_be_a_positive_number")
            }
        }
        else
        {
            error = {
                fieldName: '',
                message: ''
            }
        }

        return error;

    }

    handleSubmit(e)
    {
        e.preventDefault();
        const error = this.hasErrors();
        this.setState({ error });
        if (!error.fieldName)
        {
            if (typeof this.props.handleSubmit === "function")
            {
                this.props.handleSubmit(this.state.openItem);
            }
        }
    }

    render()
    {
        return (
            <Modal isOpen={true} backdrop={true} animation={false} fade={false} toggle={this.handleModalToggle} onOpened={this.handleModalOpen} size="lg">
                <ModalHeader
                    close={
                        <div>
                            <Button className="btn-cancel" onClick={this.handleModalToggle}>{translator.getLabel("cancel")}</Button>&nbsp;&nbsp;
                            <Button className="btn-ok" type="submit" form="openItemForm">{translator.getLabel("done")}</Button>
                        </div>
                    }
                >
                    <span className="window-title">{translator.getLabel("open_item")}</span>
                </ModalHeader>
                <ModalBody>
                    <Form id="openItemForm" onSubmit={this.handleSubmit} >
                        <Row className="mb-3">
                            <Col md={3}>
                                <InputTextComponent
                                    id="quantity"
                                    autoComplete="off"
                                    name="quantity"
                                    placeholder={translator.getLabel("open_item_quantity")}
                                    inputTextType="numeric"
                                    value={this.state.openItem.quantity}
                                    onValueChange={(value) => { this.updateOpenItem('quantity', value) }}
                                    error={this.state.error.fieldName === "quantity" ? this.state.error.message : ''}
                                    required
                                />
                            </Col>
                            <Col md={9}>
                                <InputTextComponent
                                    id="caption"
                                    autoComplete="off"
                                    name="caption"
                                    placeholder={translator.getLabel("open_item_caption")}
                                    inputTextType="text"
                                    value={this.state.openItem.caption}
                                    onValueChange={(value) => { this.updateOpenItem('caption', value) }}
                                    error={this.state.error.fieldName === "caption" ? this.state.error.message : ''}
                                    internalRef={this.inputFieldRef}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={6}>
                                <InputTextComponent
                                    id="unitPrice"
                                    autoComplete="off"
                                    name="unitPrice"
                                    placeholder={translator.getLabel("open_item_unitprice")}
                                    inputTextType="numeric"
                                    value={this.state.openItem.unitPrice}
                                    onValueChange={(value) => { this.updateOpenItem('unitPrice', value) }}
                                    error={this.state.error.fieldName === "unitPrice" ? this.state.error.message : ''}
                                    required
                                />
                            </Col>
                            <Col md={6}>
                                <InputTextComponent
                                    id="vat"
                                    autoComplete="off"
                                    name="vat"
                                    placeholder={translator.getLabel("open_item_vat")}
                                    inputTextType="numeric"
                                    value={this.state.openItem.vat}
                                    onValueChange={(value) => { this.updateOpenItem('vat', value) }}
                                    error={this.state.error.fieldName === "vat" ? this.state.error.message : ''}
                                    required
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <InputTextComponent
                                    id="instructions"
                                    type="textarea"
                                    name="instructions"
                                    placeholder={translator.getLabel("open_item_instructions")}
                                    inputTextType="text"
                                    value={this.state.openItem.instructions}
                                    style={{ height: '100px' }}
                                    onValueChange={(value) => { this.updateOpenItem('instructions', value) }}
                                    error={this.state.error.fieldName === "instructions" ? this.state.error.message : ''}
                                />
                            </Col>
                        </Row>

                    </Form>
                </ModalBody>
            </Modal>
        );
    }
}


export default OpenItem;